<template>
	<div class="vendor-manage app-region blank-t-v blank-l-h blank-r-h">
		<a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
			<a-col :span="24" :xl="8">
				<a-row :gutter="[8, 8]">
					<a-col>
						<p>厂商类型</p>
					</a-col>
					<a-col>
						<!-- 这个是绑定接口的选择列表 -->
						<a-select class="app-block" v-model="table.search.type" placeholder="请选择厂商类型">
							<a-select-option :value='1'>{{manuType(1)}}</a-select-option>
							<a-select-option :value='2'>{{manuType(2)}}</a-select-option>
						</a-select>
					</a-col>
				</a-row>
			</a-col>

			<a-col :span="24" :xl="8">
				<a-row :gutter="[8, 8]">
					<a-col>
						<p>厂商名称</p>
					</a-col>
					<a-col>
						<a-input v-model="table.search.name" placeholder="请输入厂商名称"></a-input>
					</a-col>
				</a-row>
			</a-col>

			<a-col :span="24" :xl="8">
				<a-row :gutter="[8, 8]">
					<a-col>
						<p>联系人</p>
					</a-col>
					<a-col>
						<a-input v-model="table.search.contacts" placeholder="请输入联系人"></a-input>
					</a-col>
				</a-row>
			</a-col>

			<a-col :span="24" :xl="8">
				<a-space>
					<a-button type="primary" @click="searchTable">查询</a-button>
					<a-button @click="resetSearchTable">重置</a-button>
				</a-space>
			</a-col>
		</a-row>
		<a-row class="mg-normal">
			<a-col>
				<a-space>
					<a-button type="primary" @click="newVendors()">添加厂商</a-button>
				</a-space>
			</a-col>
		</a-row>
		<a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data"
			rowKey="id" :pagination="table.page" @change="handlePageChange">
			<template slot="action" slot-scope="text, data">
				<a-space>
					<a-button type="link" @click="editVendors(data)">编辑</a-button>
					<a-button type="link" @click="deleteVendors(data)">删除</a-button>
				</a-space>
			</template>
		</a-table>
	</div>
</template>

<script>
	import { manuType } from '@/io/dict.js'
	import Vendors from '@/io/vendors.js'
	export default {
		name: 'VendorManage',
		data() {
			let self = this;
			return {
				manuType,
				
				table: {
					loading: false,
					search: {
						type: [],
						name: null,
						contacts: null,
					},
					page: {
						total: 0,
						current: 1,
						pageSize: 10,
						showQuickJumper: true,
						showSizeChanger: true,
						showTotal() {
							return `共${self.table.page.total}条`;
						}
					},
					data: [],
					columns: [{
							title: '厂商类型',
							dataIndex: 'manuType'
						},
						{
							title: '厂商名称',
							dataIndex: 'name'
						},
						{
							title: '厂商地址',
							dataIndex: 'address'
						},
						{
							title: '联系人',
							dataIndex: 'contacts'
						},
						{
							title: '操作',
							scopedSlots: {
								customRender: 'action'
							},
						}
					]
				}
			}
		},
		activated() {
			this.initData();
		},
		methods: {
			// 添加
			newVendors() {
				this.table.page.current = 1;
				this.$router.push({
					name: 'NewVendors'
				});
			},
			//编辑
			editVendors(data) {
				this.$router.push({
					name: 'EditVendors',
					params: {
						id: data.id
					},

				})
			},
			//删除
			deleteVendors(data) {
				let self = this;
				this.$confirm({
					title: '提示',
					content: '确认删除此类型？',
					onOk() {
						Vendors.del(data.id).then(res => {
							self.initData();
						}).catch(err => {});
					}
				});
			},

			searchTable() {
				this.table.page.current = 1;
				this.initData();
			},
			resetSearchTable() {
				this.table.search = {
					type: [],
					name: null,
					conctacts: null,
				};
				this.searchTable();
			},
			handlePageChange(page) {
				this.table.page.current = page.current;
				this.table.page.pageSize = page.pageSize;
				this.initData();
			},
			//包括地址
			initData() {
				this.table.loading = true;
				return Vendors.listPage(
					this.table.search.type,
					this.table.search.name,
					this.table.search.contacts,
					this.table.page.current,
					this.table.page.pageSize
				).then(res => {
					this.table.data = res.data.map(val => {
						val.region = `${val.province} / ${val.city} / ${val.area}`;
						val.stateLoading = false;
						val.intercom = val.mj_switch ? '开' : '关';
						val.gate = val.gate_switch ? '开' : '关';
						val.manuType = manuType(val.type)
						return val;
					});
					this.table.page.total = res.meta.pagination.total;
				}).catch(err => {}).finally(() => {
					this.table.loading = false;
				});
			},
		},
	}
</script>

<style lang="less" scoped>

</style>
